module.exports = __webpack_public_path__ + "img/20190816132123QQ截图20190815111004.a947f90a.png";